<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Workers'"
        :buttons="[
          {
            title: 'Add Worker',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Workers'"
        ref="agGrid"
        :data="data"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "Workers",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`Workers`)
      .then((response) => {
        this.data = response.data;
      })
      .catch((err) => {
        console.log(err);
        this.$isError(err);
      });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the worker named " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Workers/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Worker was deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
